import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';

import {
  FormConfig,
  FormField,
  IFormComponent,
  IFormConfig,
  IFormField,
} from '@models/form/form';
import { ICheckboxField, CheckboxField } from '@models/form/checkbox';

@Component({
  selector: 'app-form-checkbox',
  templateUrl: './form-checkbox.component.html',
  styleUrls: ['./form-checkbox.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormCheckboxComponent
  implements OnInit, IFormComponent<ICheckboxField>
{
  public config: IFormField<ICheckboxField> = new FormField<ICheckboxField>({
    fieldConfig: new CheckboxField(),
  });
  public formConfig: IFormConfig = new FormConfig();
  public group: UntypedFormGroup = new UntypedFormGroup({});

  public get formControl(): AbstractControl {
    return this.group.get(this.config.name);
  }

  public ngOnInit(): void {
    this.setValue(this.config.fieldConfig.checked);
  }

  private setValue(value: boolean): void {
    this.group.get(this.config.name).setValue(value);
  }
}
